// ====================================
// VisionPoint Marketing
// Accordions JS
// ====================================
(function($) {
    function openAll(){
        $('.accordion .collapse').each(function(){
            $(this).addClass('show');
        });
        $('.accordion-button').each(function(){
            $(this).attr('aria-expanded','true');
        });
    }

    //if you want to add later
    function closeAll(){
        $('.collapse').each(function(){
            $(this).removeClass('show');
        });
        $('.accordion-button').each(function(){
            $(this).attr('aria-expanded','false');
        });
    }
    $('.expand-all-btn').on('click',function(){
        openAll()
    })
    


    function shouldToggleExpand(thisObject)
    {
        let openAmount = $(thisObject).find('.js-tabs-panel.is-open').length;
        let totalAmount = $(thisObject).find('.js-tabs-panel').length; 

        if (totalAmount == openAmount) {
            $(thisObject).find(".expand-all-btn").addClass("close-all");
        } else {
            $(thisObject).find(".expand-all-btn").removeClass("close-all");
        }
    }

    let accordions = [];
    $('.-accordion').each(function(id, data) {
        accordions.push(new AccordionTabs(data, {
            breakpoint: 800,
            tabsAllowed: false,
            selectedTab: 0,
            startCollapsed: false
        }));
        $(this).find('.expand-all-btn').on('click keypress', function() {
            
            let openAmount = $(this).closest('.wf-accordion').find('.js-tabs-panel.is-open').length;
            let closedAmount = $(this).closest('.wf-accordion').find('.js-tabs-panel').length - openAmount;            

            if (closedAmount == 0) {
                //Close them
                $(this).closest('.wf-accordion').find('.js-tabs-panel').removeClass('is-open');
                $(this).closest('.wf-accordion').find('.content').removeClass('is-open');
                $(this).closest('.wf-accordion').find('.js-tabs-panel').addClass('is-hidden');
                $(this).closest('.wf-accordion').find('.content').addClass('is-hidden');
            } else {
                //open them
                $(this).closest('.wf-accordion').find('.js-tabs-panel').addClass('is-open');
                $(this).closest('.wf-accordion').find('.content').addClass('is-open');
                $(this).closest('.wf-accordion').find('.js-tabs-panel').removeClass('is-hidden');
                $(this).closest('.wf-accordion').find('.content').removeClass('is-hidden');
            }
            shouldToggleExpand($(this).closest('.wf-accordion'));
        });
        $('.accordion-trigger').on('click keypress', function() {
            shouldToggleExpand($(this).closest('.wf-accordion'));
        });
    });

})(jQuery);    